// Dependency
import React from 'react';
import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';


// Components
import Quantity from '../../quantity/quantity';
import { useCart } from '../../../contexts/cart-context';
import UtilsService from '../../../services/utils.service';

// Styles
import * as styles from './cart-item.module.scss';

// Assets
import iconRemove from '../assets/icon-remove.svg';

// Template
const CartItem = ({item}) => {

  const { removeFromCart } = useCart();

  const { t } = useTranslation();

  return (
    <article className={`${styles.cartListItem}`}>
      <Link to={`/${UtilsService.getLocaleFromUrl().country}/${t('slug.product')}/${item.product.uri}/`} className={`${styles.cartListItem__img} cd-background-img`}>
        <div className={styles.cartListItemImg__placeholder}>
          <img src={item.product.media.standard[0]} alt={item.product.name} />
        </div>
      </Link>
      <div className={`${styles.cartListItem__content}`}>
        <h1 className={`${styles.cartListItem__title}`}>{item.product.name}</h1>
        <p className={`${styles.cartListItem__price}`}>
          <strong className={item.anyDiscount ? 'cd-price-red' : ''}>{item.priceEach}</strong>
          { item.anyDiscount ? <small>{item.priceEachBeforeDiscount}</small> : ''}
        </p>
        <button className={`${styles.cartListItem__remove}`} onClick={() => {removeFromCart(item.line, item.product,item.quantity )}}>
          <img src={iconRemove} alt="Remove this item" />
        </button>
        <Quantity key={item.line} quantity={item.quantity} line={item.line} item={item.product} />
      </div>
    </article>
  );
};

export default CartItem;